module.exports = new __parcel__URL__("aboutMap.bac5be5d.png").toString();